import { store } from "@/store";
import { makeRequest } from "@/util";
import { AccountMetadata, SET_ACCOUNT_METADATA } from "@/reducers/environments";

export interface UpdateCompanyDetailsPayload {
  newName: string;
}

export async function updateCompanyDetails(
  payload: UpdateCompanyDetailsPayload,
) {
  const { data } = await makeRequest<AccountMetadata>(
    "update_company_details",
    payload,
  );

  const currentState = store.getState();
  const currentAccountMetadata = currentState.environments.accountMetadata;
  store.dispatch({
    type: SET_ACCOUNT_METADATA,
    payload: {
      ...currentAccountMetadata,
      companyDetails: {
        ...currentAccountMetadata?.companyDetails,
        ...data.companyDetails,
      },
    },
  });

  return data;
}
